import { render, staticRenderFns } from "./CNICPromosExpiringInAMonth.vue?vue&type=template&id=64d090ac"
import script from "./CNICPromosExpiringInAMonth.vue?vue&type=script&lang=js"
export * from "./CNICPromosExpiringInAMonth.vue?vue&type=script&lang=js"
import style0 from "./CNICPromosExpiringInAMonth.vue?vue&type=style&index=0&id=64d090ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports